var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.nameList.length > 1)?_c('div',{staticClass:"box c-p-lr-20"},[_c('div',{staticClass:"r c-m-r-20"},[_c('van-dropdown-menu',[_c('van-dropdown-item',{attrs:{"options":_vm.nameList,"title-class":"vpn_title"},on:{"change":_vm.changeId},model:{value:(_vm.value1),callback:function ($$v) {_vm.value1=$$v},expression:"value1"}})],1)],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }